module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-start-selling-flower@2x-e869ec24e880bb61e9e1aee03c98c993.png";